import { render, staticRenderFns } from "./CardCompany.vue?vue&type=template&id=1dd27380"
import script from "./CardCompany.vue?vue&type=script&lang=js"
export * from "./CardCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports